import base from '@/http/url_base';

export default {
  QUESTION: base.API_RH + '/entretiens/questions',
  QUESTION_NUMBER: base.API_RH + '/entretiens/questions/number',
  QCM: base.API_RH + '/entretiens/questions/qcm',
  QRM: base.API_RH + '/entretiens/questions/qrm',
  QVF: base.API_RH + '/entretiens/questions/qvf',
  QN: base.API_RH + '/entretiens/questions/qn',
  QC: base.API_RH + '/entretiens/questions/qc',
  QL: base.API_RH + '/entretiens/questions/ql',
  QRS: base.API_RH + '/entretiens/questions/qrs',
};
